import React from "react";
import "../css/terms.scss";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "The demonstration",
    paragraphs: [
      "anackmira is a brand operated by SPRAYJOY LIMITED and is currently a front-end demonstration of a browser-game storefront. No account is required. Checkout does not charge money, and an apparent purchase creates only a local order and unlock flag on the current browser.",
    ],
  },
  {
    title: "Using the games",
    paragraphs: [
      "You may play the included original games for personal demonstration and evaluation. Do not attempt to represent local unlock records as transferable licences, resale rights or proof of payment.",
    ],
    list: [
      "Game progress is device-local",
      "Availability is not guaranteed across browsers",
      "No cloud save, activation key or multiplayer service is provided",
    ],
  },
  {
    title: "Fair use and conduct",
    paragraphs: [
      "Do not interfere with the interface, distribute harmful code through it, or use automated activity to misrepresent scores or orders. Local modifications are outside the intended demonstration experience.",
    ],
  },
  {
    title: "Content and availability",
    paragraphs: [
      "Game titles, artwork and interface copy in this project are original demonstration content. Features may change while the product is under development. The service is provided for evaluation without a promise of uninterrupted availability.",
    ],
  },
  {
    title: "Production terms still required",
    paragraphs: [
      "These terms are a pre-launch draft, not a substitute for terms reviewed for the actual operator, payment model, consumer market and governing law. They must be updated before real commercial use.",
    ],
  },
];
function Terms() {
  return (
    <PolicyPage
      kicker="Terms"
      title="Terms for a playable prototype."
      summary="The rules and limits that match anackmira’s current browser-only implementation."
      sections={sections}
    />
  );
}
export default Terms;
